import { useState } from "react";
import api from "../api";

const useGetSubmissionByID = () => {
  const [loading, setLoading] = useState(false);
  const [submission, setSubmission] = useState(null);

  const fetchSubmissionByID = async (submissionID) => {
    setLoading(true);

    const { data } = await api.get(`/submission/${submissionID}`);

    setSubmission(data);

    setLoading(false);
  };

  return { loading, submission, fetchSubmissionByID };
};

export { useGetSubmissionByID };
